import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;
const idFlowSaveFile = process.env.REACT_APP_ID_FLOW_UPLOAD_FILE_S3;
const idFlowSaveData = process.env.REACT_APP_ID_FLOW_SAVE_INFO_DIGITAL_SIGNATURE;
const idFlowFinishSign = process.env.REACT_APP_ID_FLOW_SAVE_FINAL_INFO_SEND_EMAIL_DIGITAL_SIGNATURE;

export const SaveFiles = (accessToken, dto) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            "id_flow": idFlowSaveFile,
            "id": dto.id,
            "name": dto.name,
            "file": dto.file
        })
    })
}

export const SaveData = (accessToken, base64) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            "id_flow": idFlowSaveData,
            "data": base64
        })
    })
}

export const FinishSignature = (accessToken, id_unique) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            "id_flow": idFlowFinishSign,
            "id_unique": id_unique
        })
    })
}